/** @jsxImportSource @emotion/react */
import { Badge, Table } from "reactstrap";
import { DeviceEventStatusColor } from "../../../../actions/Devices/constants";
import { formatDateTime } from "../../Layers/fields/formatters";
import { registerItems } from "./RegisterData";

interface DeviceEvent {
    id: string;
    command: string;
    data: {
        register_name?: string;
        value?: string;
        first_name?: string;
        user_id?: number;
        [key: string]: any;
    };
    status: string;
    date_created: string;
    date_updated: string;
}

interface RipeningRoomEventsProps {
    events: DeviceEvent[];
}

export default function RipeningRoomEvents({ events }: RipeningRoomEventsProps) {
    // Filter and sort events to show only WRITE_REGISTER events in logical order


    if (events.length === 0) {
        return null;
    }

    const formatDate = (dateString: string) => {
        return formatDateTime(dateString);
    };

    const getRegisterConfig = (registerName: string) => {
        const key = registerName.split("_")[0];
        return registerItems[key] || {};
    };

    return (
        <div>
            <h6 className="mb-3">Device Events</h6>
            <div className="table-responsive">
                <Table size="sm" className="mb-0">
                    <thead>
                        <tr>
                            <th>Register</th>
                            <th>Value</th>
                            <th>Date</th>
                            <th>User</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.map((event) => (
                            <tr key={event.id}>
                                <td>
                                    <span className="fw-medium">
                                        {getRegisterConfig(event?.data?.register_name || "")?.label || event.data.register_name}
                                    </span>
                                </td>
                                <td>
                                    <span className="fw-bold">
                                        {getRegisterConfig(event?.data?.register_name || "")?.options?.find((i) => i.value === event.data.value)?.label || event.data.value || "N/A"}
                                    </span>
                                </td>
                                <td>
                                    {formatDate(event.date_created)}
                                </td>
                                <td>
                                    {event.data.first_name || "Unknown"}
                                </td>
                                <td>
                                    <Badge
                                        color={DeviceEventStatusColor[event.status] || "light"}
                                        size="sm"
                                    >
                                        {event.status}
                                    </Badge>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    );
}
